import _construct from "@babel/runtime/helpers/construct";

/** 所有的流程集合 */

/**
 * 分离 "或" 类
 *
 * @description
 * ```typescript
 * class A {}
 * class B {}
 * const M: typeof A | typeof B = null
 * const m = new M()
 *
 * // 此时 M 实际是
 * const M: new () => A | B
 * 因此这里需要将他改成
 * const M: new (...args: ConstructorParameters<A>) => A | new (...args: ConstructorParameters<B>) => B
 * 否则无法根据 KEY 对应集合中的某个值
 * ```
 */

/**
 * 根据平台获取模块
 * @param name 模块名称
 * @description
 * 根据支持情况自动获取对应的平台代码
 */
export var fetchModule = function fetchModule(name) {
  var _document;

  if (typeof ((_document = document) === null || _document === void 0 ? void 0 : _document.cookie) !== 'undefined' && typeof XMLHttpRequest !== 'undefined') {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    var _require = require('./platform/browser'),
        Browser = _require['default'];

    return Browser === null || Browser === void 0 ? void 0 : Browser[name];
  }
};
/**
 * 创建启动器
 * @param name 模块名称
 * @description
 * 加载对应的平台并且返回实例化函数
 */

export var craeteLauncher = function craeteLauncher(name) {
  return function create() {
    var Module = fetchModule(name);

    if (!Module) {
      throw new Error('Not supported');
    }

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _construct(Module, args);
  };
};